//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { messageUpdateApi } from '@/api/setting';
export default {
  name: 'MessageTimes',
  components: {},
  props: {
    messageData: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      dialogVisible: false,
      loading: false,
      hour: 0,
      minute: 0,
      form: {
        date: ''
      },
      rules: {
        date: [{
          required: true,
          message: '请选择提醒时间',
          trigger: 'change'
        }]
      }
    };
  },
  watch: {
    messageData: {
      handler: function handler(nVal, oVal) {
        if (nVal.data.remind_time) {
          this.form.date = nVal.data.remind_time;
          this.hour = Math.floor(this.form.date / 3600);
          this.minute = Math.floor(this.form.date % 3600 / 60);
        } else {
          this.form.date = '';
        }
      },
      deep: true
    }
  },
  methods: {
    handleClose: function handleClose() {
      this.dialogVisible = false;
      this.$refs.form.resetFields();
    },
    handleOpen: function handleOpen() {
      this.dialogVisible = true;
    },
    handleConfirm: function handleConfirm() {
      var _this = this;
      if (this.messageData.type == 1) {
        this.form.date = parseInt(this.hour * 3600) + parseInt(this.minute * 60);
      }
      this.$refs.form.validate(function (valid) {
        if (valid) {
          _this.loading = true;
          messageUpdateApi(_this.messageData.data.id, {
            remind_time: _this.form.date
          }).then(function (res) {
            _this.loading = false;
            _this.handleClose();
            _this.$emit('isOk');
          }).catch(function (error) {
            _this.loading = false;
          });
        }
      });
    }
  }
};